import { render, staticRenderFns } from "./record_expenses.vue?vue&type=template&id=b9a5ef14"
import script from "./record_expenses.vue?vue&type=script&lang=js"
export * from "./record_expenses.vue?vue&type=script&lang=js"
import style0 from "./record_expenses.vue?vue&type=style&index=0&id=b9a5ef14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports